export const FontLoader = () => (
  <style>{`
    @font-face {
      font-family: 'Sentient';
      font-style: normal;
      font-weight: 100 900;
      font-display: swap;
      src: url('/fonts/Sentient-Variable.woff2') format('woff2');
    }
    @font-face {
      font-family: 'Sentient';
      font-style: italic;
      font-weight: 100 900;
      font-display: swap;
      src: url('/fonts/Sentient-VariableItalic.woff2') format('woff2');
    }
    @font-face {
      font-family: 'IBM Plex Mono';
      font-style: normal;
      font-weight: 400;
      font-display: swap;
      src: url('/fonts/IBMPlexMono-Regular.woff2') format('woff2');
    }
    @font-face {
      font-family: 'IBM Plex Mono';
      font-style: normal;
      font-weight: 500;
      font-display: swap;
      src: url('/fonts/IBMPlexMono-Medium.woff2') format('woff2');
    }
    @font-face {
      font-family: 'IBM Plex Mono';
      font-style: normal;
      font-weight: 600;
      font-display: swap;
      src: url('/fonts/IBMPlexMono-SemiBold.woff2') format('woff2');
    }
  `}</style>
)
